import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GiFinSimulacaoFinanciadoraModel } from "../../../dominio/gi-fin-simulacao-financiadora-model";
import { FinSimulacaoService, JustificativaFinanciadoraRequest } from "../../../services/fin-simulacao.service";
import { NotificacaoService } from "../../../services/notificacao.service";
import { CarregandoService } from "../../../services/carregando.service";

export interface JustificativaNegativaSimulacaoResult {
  justificativa: string;
  financiadoras: JustificativaFinanciadoraRequest[];
}

interface FinanciadoraNegativa {
  vinculo: GiFinSimulacaoFinanciadoraModel;
  exibir: boolean;
  justificativa: string | null;
}

@Component({
  selector: "app-justificativa-negativa-simulacao-modal",
  templateUrl: "./justificativa-negativa-simulacao-modal.component.html",
  styleUrls: ["./justificativa-negativa-simulacao-modal.component.scss"],
})
export class JustificativaNegativaSimulacaoModalComponent implements OnInit {
  readonly tamanhoMaximo = 1000;

  idTarefa: number;
  justificativa = "";
  financiadoras: FinanciadoraNegativa[] = [];

  constructor(
    private dialogRef: MatDialogRef<JustificativaNegativaSimulacaoModalComponent, JustificativaNegativaSimulacaoResult>,
    @Inject(MAT_DIALOG_DATA) public data: { idTarefa: number },
    private finSimulacaoService: FinSimulacaoService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
  ) {
    this.idTarefa = data.idTarefa;
  }

  ngOnInit() {
    this.buscarFinanciadoras();
  }

  buscarFinanciadoras() {
    this.carregandoService.mostra("buscarFinanciadorasNegativa");

    this.finSimulacaoService.buscarFinanciadorasPorTarefa(this.idTarefa).subscribe(
      (data) => {
        this.financiadoras = (data.results || []).map((vinculo) => ({
          vinculo,
          exibir: !!vinculo.visivel,
          justificativa: vinculo.justificativaNegativa || null,
        }));

        this.financiadoras.forEach((f) => this.buscarSumario(f.vinculo));

        this.carregandoService.esconde("buscarFinanciadorasNegativa");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFinanciadorasNegativa");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarSumario(vinculo: GiFinSimulacaoFinanciadoraModel) {
    this.finSimulacaoService.buscaSumarioFinanciadoraCelulaCredito(this.idTarefa, vinculo.id).subscribe(
      (data) => {
        vinculo.sumario = data.result;
      },
      () => { }
    );
  }

  confirmar() {
    if (!this.justificativa || !this.justificativa.trim()) {
      return;
    }

    this.dialogRef.close({
      justificativa: this.justificativa.trim(),
      financiadoras: this.financiadoras.map((f) => ({
        idVinculo: f.vinculo.id,
        exibir: f.exibir,
        justificativa: f.exibir && f.justificativa && f.justificativa.trim() ? f.justificativa.trim() : null,
      })),
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
